import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import UIButton from 'UIComponents/button/UIButton';
import { getPlaylistAssignmentsUrl, PlaylistAssignmentsForPortalTable, PlaylistAssignmentsTablePage, usePlaylistAssignmentsForPortal, usePlaylistAssignmentsParams } from '..';
import { FormattedMessage } from '../../../components/I18n';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
import { useMediaQuery } from '../../../utils/Styling';
import { ExportButton } from '../../export';
import { usePortal } from '../../portals';

const PlaylistAssignmentsForPortalCount = ({
  playlistId,
  portalId
}) => {
  const {
    total
  } = usePlaylistAssignmentsForPortal({
    playlistId,
    portalId
  });
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: `learningCenter.playlistAssignments.assignmentsCount`,
    options: {
      count: total
    }
  });
};

const PlaylistAssignmentsForPortal = ({
  playlistId,
  portalId: propPortalId
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const {
    portalId: paramPortalId
  } = usePlaylistAssignmentsParams();
  const portalId = propPortalId || Number(paramPortalId);
  const {
    portal
  } = usePortal({
    portalId
  });
  return /*#__PURE__*/_jsx(PlaylistAssignmentsTablePage, {
    actions: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(UIButton, {
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlistAssignments.assignPlaylist"
        })
      }), !isMobile && /*#__PURE__*/_jsx(ExportButton, {
        exportType: "PLAYLIST_ASSIGNMENTS"
      })]
    }),
    backButton: {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistAssignments.backLink"
      }),
      to: getPlaylistAssignmentsUrl(playlistId)
    },
    enabledFilters: [FILTER_TYPES.SEARCH_USER],
    headerTitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.playlistAssignments.assignmentsForPortalHeader",
      options: {
        portalName: portal && portal.companyName || ''
      }
    }),
    tableCount: /*#__PURE__*/_jsx(PlaylistAssignmentsForPortalCount, {
      playlistId: playlistId,
      portalId: portalId
    }),
    children: /*#__PURE__*/_jsx(PlaylistAssignmentsForPortalTable, {
      playlistId: playlistId,
      portalId: portalId
    })
  });
};

export default PlaylistAssignmentsForPortal;